import { Memo } from 'shared/models';

export function getMemoGroupType(group: Memo[]): 'mine' | 'others' | 'mixed' {
  return group.every((memo) => memo.is_mine)
    ? 'mine'
    : group.every((memo) => !memo.is_mine)
    ? 'others'
    : 'mixed';
}
